import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseModalComponent } from '../../../../models/base/base-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonTypeEnum } from '../../../../ui/buttons/button/button-type.enum';
import { ButtonComponent } from '../../../../ui/buttons/button/button.component';
import { CloseButtonComponent } from '../../../../ui/buttons/close-button/close-button.component';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-base-action-modal',
  standalone: true,
  templateUrl: './base-action-modal.component.html',
  imports: [ButtonComponent, CloseButtonComponent, NgIf, NgClass],
  styleUrls: ['./base-action-modal.component.scss']
})
export class BaseActionModalComponent extends BaseModalComponent {
  // Ensure title is localized before being passed in
  @Input() modalTitle: string = '';
  // Ensure primaryLabel is localized before being passed in
  @Input() primaryLabel: string = '';
  // Ensure secondaryLabel is localized before being passed in
  @Input() secondaryLabel: string = '';

  @Input() hidePrimary: boolean = false;
  @Input() hideSecondary: boolean = false;
  @Input() hideClose: boolean = false;
  // Use in conjunction with ignoreEscapeModalOptions to ensure the modal
  // cannot be closed on escape
  @Input() ignoreEscape: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() disablePrimary: boolean = false;

  @Output() closeClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() primaryClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() secondaryClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(private activeModal: NgbActiveModal) {
    super(activeModal);
  }

  setupBindings(): void {}

  setupViews(): void {}

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
